import React, { useState } from "react";
import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";
import useFacebookSDK from "../../hooks/useFacebookSDK";

/**
 * Wrapper para FacebookLogin que carrega o SDK com o appId correto
 * para Facebook/Instagram (diferente do WhatsApp Business)
 * O SDK só é carregado quando o usuário clica no botão
 */
const FacebookLoginWithSDK = ({ children, appId, ...props }) => {
  const { loading: sdkLoading, loadSDK } = useFacebookSDK(appId);
  const [isInitializing, setIsInitializing] = useState(false);

  const handleClick = async (onClick) => {
    setIsInitializing(true);
    try {
      // Carregar SDK com o appId correto antes de iniciar
      await loadSDK();
      // Chamar o onClick original do FacebookLogin
      onClick();
    } catch (error) {
      console.error('Erro ao carregar SDK do Facebook:', error);
    } finally {
      setIsInitializing(false);
    }
  };

  // Desabilita enquanto o SDK está carregando
  if (sdkLoading || isInitializing) {
    return React.cloneElement(children, {
      disabled: true,
      ...children.props
    });
  }

  return (
    <FacebookLogin
      appId={appId}
      autoLoad={false}
      {...props}
      render={(renderProps) => React.cloneElement(children, {
        onClick: () => handleClick(renderProps.onClick),
        ...children.props
      })}
    />
  );
};

export default FacebookLoginWithSDK;
